<template>
    <div class="row">
        <div class="col-md-10">
            <h2>Request Vehicle</h2>
            <div class="text">
                <p>
                    Please enter your target vehicles. This information will be forwarded to our Sales Consultant who can then source these vehicles on your behalf. Should you have any queries, please do not hesitate to contact our office on +64 3 377 6578.
                </p>
            </div>
        </div>
        <div class="col-md-12">
            <div class="row">
                <div class="col-lg-6 col-md-12">
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="company">Company</label>
                            <input type="text" id="company" value="" placeholder="Company" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="name">Your name<span class="required">*</span></label>
                            <input type="text" id="name" value="" placeholder="Your name" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="email">Email<span class="required">*</span></label>
                            <input type="email" id="email" value="" placeholder="Email" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="phone">Phone</label>
                            <input type="text" id="phone" value="" placeholder="Phone" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="fax">Fax</label>
                            <input type="text" id="fax" value="" placeholder="Fax" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label for="message">Message</label>
                            <textarea name="message" id="message" cols="3" rows="5" placeholder="Message"></textarea>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12">
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="make">Make</label>
                            <input type="text" id="make" value="" placeholder="Make" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="model">Model<span class="required">*</span></label>
                            <input type="text" id="model" value="" placeholder="Model" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="year">Year</label>
                            <input type="text" id="year" value="" placeholder="Year">
                        </div>
                        <div class="form-group col-md-6">
                            <label for="condition_min">Auction grade</label>
                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <select id="condition_min" name="condition_min" class="form-control">
                                        <option value="" selected>Min</option>
                                        <option value="0.0">0.0</option>
                                        <option value="2.0">2.0</option>
                                        <option value="3.0">3.0</option>
                                        <option value="3.5">3.5</option>
                                        <option value="4.0" selected="TRUE">4.0</option>
                                        <option value="4.5">4.5</option>
                                        <option value="5.0">5.0</option>
                                        <option value="9.0">9.0</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2 middle">
                                    <span>to</span>
                                </div>
                                <div class="form-group col-md-5">
                                    <select id="condition_max" name="condition_max" class="form-control">
                                        <option value="" selected>Max</option>
                                        <option value="0.0">0.0</option>
                                        <option value="2.0">2.0</option>
                                        <option value="3.0">3.0</option>
                                        <option value="3.5">3.5</option>
                                        <option value="4.0">4.0</option>
                                        <option value="4.5">4.5</option>
                                        <option value="5.0">5.0</option>
                                        <option value="9.0">9.0</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row" id="mileage">
                        <div class="form-group col-md-6">
                            <label for="mileage_min">Mileage</label>
                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <input type="text" name="mileage_min" id="mileage_min" class="form-control" /><span>,000</span>
                                </div>
                                <div class="form-group col-md-2 middle">
                                    <span>to</span>
                                </div>
                                <div class="form-group col-md-5">
                                    <input type="text" name="mileage_max" id="mileage_max" class="form-control" /><span>,000</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="transmission">Transmission<span class="required">*</span></label>
                            <input type="text" id="transmission" value="" placeholder="Transmission" />
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="chassis">Chassis</label>
                            <input type="text" id="chassis" value="" placeholder="Chassis" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="engine_cc_min">Engine CC</label>
                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <input type="text" name="engine_cc_min" placeholder="Min" id="engine_cc_min" class="form-control">
                                </div>
                                <div class="col-md-2 middle">
                                    <span>to</span>
                                </div>
                                <div class="form-group col-md-5">
                                    <input type="text" name="engine_cc_max" placeholder="Max" id="engine_cc_max" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="fuel_type">Fuel Type</label>
                            <select name="fuel_type" id="fuel_type" class="form-control">
                                <option value="" selected>All</option>
                                <option value="p">petrol / unspecified</option>
                                <option value="d">diesel</option>
                                <option value="o">other</option>
                            </select>
                        </div>
                        <div class="form-group col-md-6">
                            <label for="start_bid_min">Start Bid (NZD)</label>
                            <div class="form-row">
                                <div class="form-group col-md-5">
                                    <input type="text" name="start_bid_min" id="start_bid_min" placeholder="Min" class="form-control">
                                </div>
                                <div class="col-md-2 middle">
                                    <span>to</span>
                                </div>
                                <div class="form-group col-md-5">
                                    <input type="text" name="start_bid_max" placeholder="Max" id="start_bid_max" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <button type="submit" class="btn">Send Request</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>



// WEBPACK FOOTER //
// resources/js/components/RequestVehicle.vue